module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-10.jpg?v=d61aa156";